import React__default from 'react';
import { Text } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';

const NoSearchResultsText = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(Text, {
    size: "base",
    color: "secondary",
    withMargin: true
  }, formatMessage({
    id: 'search-no-results'
  }));
};

export { NoSearchResultsText as N };
//# sourceMappingURL=NoSearchResultsText-bCN79yD5.js.map
